import React from 'react';

interface AvatarProps {
  nome?: string;
  fotoUrl?: string;
  size?: number;
  className?: string;
}

function iniciais(nome?: string): string {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function corPorNome(nome?: string): string {
  const cores = [
    'from-purple-500 to-purple-700',
    'from-blue-500 to-blue-700',
    'from-emerald-500 to-emerald-700',
    'from-amber-500 to-amber-700',
    'from-rose-500 to-rose-700',
    'from-cyan-500 to-cyan-700',
    'from-fuchsia-500 to-fuchsia-700',
    'from-orange-500 to-orange-700',
  ];
  if (!nome) return cores[0];
  let h = 0;
  for (let i = 0; i < nome.length; i++) h = (h * 31 + nome.charCodeAt(i)) >>> 0;
  return cores[h % cores.length];
}

const AvatarColaborador: React.FC<AvatarProps> = ({ nome, fotoUrl, size = 40, className = '' }) => {
  if (fotoUrl) {
    return (
      <img
        src={fotoUrl}
        alt={nome || ''}
        style={{ width: size, height: size }}
        className={`rounded-full object-cover ring-2 ring-white shadow-sm ${className}`}
      />
    );
  }
  const cor = corPorNome(nome);
  const font = size >= 56 ? 'text-base' : size >= 40 ? 'text-sm' : 'text-xs';
  return (
    <div
      style={{ width: size, height: size }}
      className={`rounded-full bg-gradient-to-br ${cor} flex items-center justify-center text-white font-bold ${font} ring-2 ring-white shadow-sm ${className}`}
    >
      {iniciais(nome)}
    </div>
  );
};

export default AvatarColaborador;
